import React from 'react';
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import About from './components/About';
import PearlSection from './components/PearlSection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Banner />
      <About />
      <PearlSection type="white" title="White South Sea Pearls" />
      <PearlSection type="golden" title="Golden South Sea Pearls" />
      <PearlSection type="black" title="Tahitian Pearls" />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App; 